// 判断各类型blur的时候value是否是空值
export function isEmptyValue(value, itemtype) {
    if (itemtype === 'residtxt') {
        return Object.keys(value).every(key => !value[key]?.value);
    } else if (itemtype === 'refer') {
        if (Array.isArray(value)) {
            return !value.length;
        } else {
            return !value.refpk;
        }
    } else {
        return (typeof value === 'boolean' && value !== true) && !!value;
    }
}

// 产生随机key值
export function getRandom() {
    return String(new Date().getTime()).slice(-5) + getSafeRandom().toString(12);
} 

export function getSafeRandom() {
    const crypto = window.crypto || window.msCrypto;
    var array = new Uint32Array(1);
    let random = crypto.getRandomValues(array)[0];
    return random * Math.pow(10, -10);
}

// 获取relation -> tables
export function getRelationTables(relation) {
    let { stores, configs, pageScope } = this.props;
    let { tables, tabs: tabsInfo } = relation;
    return tables.filter(tableId => {
        let { hideTableTabs, customTabContent } = configs[tableId] || {},
            activeTab = stores[tableId].getActiveTab() || tableId;

        let tabs = tabsInfo[tableId].filter(tab => {
            return stores[tab].getAreaVisible() && (pageScope.state.meta?.[tab]?.areaVisible !== false || customTabContent?.[tab]);
        });

        let tabVisible = !hideTableTabs && tabs.length,
            bodyVisible = typeof customTabContent?.[activeTab] === 'function' ? customTabContent[activeTab](activeTab) : (hideTableTabs || tabs.length);
        
        return tabVisible || bodyVisible;
    });
}

// 将16进制颜色转换为 HSL 颜色
export function  hexToHsl  (hex) {
    if(!hex){
        return  {
            h: null,
            s: null,
            l: null,
        };
    }
    hex = hex.substring(1);
    hex = hex.length === 3 ? hex + hex : hex;
    // 将16进制颜色转换为RGB颜色
    const r = parseInt(hex.substring(0, 2), 16) / 255;
    const g = parseInt(hex.substring(2, 4), 16) / 255;
    const b = parseInt(hex.substring(4, 6), 16) / 255;

    // 计算最大值和最小值
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);

    // 计算亮度、饱和度和色相
    const l = (max + min) / 2;
    const s = max === min ? 0 : l > 0.5 ? (max - min) / (2 - max - min) : (max - min) / (max + min);
    const h = max === min ? 0
        : max === r
            ? ((g - b) / (max - min) + (g < b ? 6 : 0)) / 6
            : max === g
                ? ((b - r) / (max - min) + 2) / 6
                : ((r - g) / (max - min) + 4) / 6;

    // 将色相、饱和度和亮度转换为HSL颜色
    const hsl = {
        h: Math.round(h * 360),
        s: Math.round(s * 100),
        // 暗黑主题更改传入的背景色  L值改为 22
        l: Math.round(l * 100),
    };
     
    return hsl;
}